import PreloadEuroNews from '../../../../workers/preload-euro-news.worker';
import { createEndpoint, Type } from '../../models/europrisme';
import { idbPutEuronewsRecords } from '../../models/idb';
import {
  GET_EURONEWS_REJECTED,
  GET_EURONEWS_REQUESTED,
  GET_EURONEWS_RESOLVED,
} from '../types';

export const getEuroNewsRequested = () => ({
  type: GET_EURONEWS_REQUESTED,
});

export const getEuroNewsResolved = data => ({
  type: GET_EURONEWS_RESOLVED,
  payload: { data },
});

export const getEuroNewsRejected = error => ({
  type: GET_EURONEWS_REJECTED,
  payload: error,
});

export const getEuroNewsEndpoint = createEndpoint(
  Type.XML,
  'getEuroNews',
  {
    sContext: '',
  },
  {
    request: getEuroNewsRequested,
    resolve: getEuroNewsResolved,
    reject: getEuroNewsRejected,
  },

  data => {
    try {
      const { xmlst } = data;
      const { Success } = xmlst;

      return Success === 'TRUE';
    } catch (error) {
      return false;
    }
  },
);

export const getEuroNews = ({ port = 6174, baseURL }) => async (
  dispatch,
  getState,
) => {
  const { users } = getState();
  const { currentUser } = users || {};

  return new Promise((resolve, reject) => {
    const worker = new PreloadEuroNews();

    worker.onmessage = async ({ data }) => {
      try {
        if (data.type === 'PRELOAD_EURO_NEWS_RESOLVED') {
          if (data.success) {
            const records = data.value?.xmlst?.EuroNews?.Item || [];

            if (records) {
              await idbPutEuronewsRecords(records);
              await dispatch(getEuroNewsResolved(records));

              return resolve(records);
            }
          }

          dispatch(
            getEuroNewsRejected(data.error, {
              __request: { uuid: 'idb' },
            }),
          );

          return reject(data.error);
        }
      } catch (error) {
        console.error('[EuroNews action]', error);
      }
    };

    dispatch(getEuroNewsRequested());

    worker.postMessage({
      type: 'PRELOAD_EURO_NEWS',
      port,
      baseURL,
      customerID: currentUser?.customerID || '',
      location: JSON.stringify({ ...window.location }),
    });
  });
};

export const EURO_NEWS_ACTIONS = {
  getEuroNews,
};
